var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2628 12.9738C13.2628 12.9738 8.78609 13.4697 5.79976 13.8012C5.53059 13.8338 5.29259 14.0137 5.20334 14.2871C5.11409 14.5605 5.20334 14.8453 5.40168 15.0252C7.62017 17.0496 10.9536 20.0813 10.9536 20.0813C10.9508 20.0813 10.0384 24.4913 9.43209 27.4338C9.38109 27.7001 9.47742 27.982 9.70976 28.1506C9.94067 28.3192 10.2382 28.322 10.4719 28.1903C13.0843 26.7056 16.9971 24.4729 16.9971 24.4729C16.9971 24.4729 20.9113 26.7056 23.5194 28.1917C23.7574 28.322 24.0549 28.3192 24.2858 28.1506C24.5182 27.982 24.6145 27.7001 24.5621 27.4352C23.9558 24.4913 23.0448 20.0813 23.0448 20.0813C23.0448 20.0813 26.3783 17.0496 28.5968 15.0294C28.7951 14.8438 28.8829 14.5591 28.7951 14.2871C28.7073 14.0151 28.4693 13.8352 28.2001 13.804C25.2138 13.4697 20.7357 12.9738 20.7357 12.9738C20.7357 12.9738 18.8798 8.86834 17.6431 6.13134C17.5269 5.88626 17.2833 5.71484 16.9971 5.71484C16.7109 5.71484 16.4658 5.88768 16.3553 6.13134C15.1172 8.86834 13.2628 12.9738 13.2628 12.9738Z",
    fill: "#FF8533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.82c3b947ca1a8ec7c663d4f383719128.svg";
export { ForwardRef as ReactComponent };